// likely will want to make topclan's own individual js and scss eventually
import React from 'react';
import ReactDOM from 'react-dom';    
import App from "./components/App/App";    

ReactDOM.render(<App />, document.getElementById('clanleaderboard-root')); 
